import { useState } from "react";
import { Button, List } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import "./DokumentList.css";
import { formatDateTime } from "../../utils/formatDateTime";

function DokumentsList({ dokumenti, onDeleteClick }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentDokumenti = dokumenti.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(dokumenti.length / itemsPerPage);

  const handleOpenPdf = async (dokument) => {
    if (!dokument.putanja) return;

    const filename = dokument.putanja.split("/").pop();
    const url = `/dokument/preview/${filename}`;

    const isPdf = filename.toLowerCase().endsWith(".pdf");

    if (isPdf) {
      window.open(url, "_blank");
    } else {
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Network response was not ok");

        const blob = await response.blob();
        const downloadUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadUrl);
        }, 100);
      } catch (error) {}
    }
  };

  return (
    <div className="documents-list-container">
      <List
        header={
          <div className="list-header">
            <div className="dokument-col-placeholder"></div>
            <div className="dokument-col-naslov">Naslov</div>
            <div className="dokument-col-autor">Autor</div>
            <div className="dokument-col-datum">Datum objave</div>
            <div className="dokument-col-tip">Tip</div>
            <div className="dokument-col-akcije">Akcije</div>
          </div>
        }
        locale={{ emptyText: "Nema dostupnih dokumenata." }}
        bordered
        dataSource={currentDokumenti}
        renderItem={(dokument) => (
          <List.Item onClick={() => handleOpenPdf(dokument)}>
            <div className="list-row-dokument">
              <div className="dokument-col-placeholder"></div>
              <div className="dokument-col-naslov">{dokument.naziv}</div>
              <div className="dokument-col-autor">{dokument.autor}</div>
              <div className="dokument-col-datum">
                {formatDateTime(dokument.datumDodavanja)}
              </div>
              <div className="dokument-col-tip">
                {dokument.putanja.split(".").pop()}
              </div>
              <div className="dokument-col-akcije">
                <Button
                  icon={<DeleteOutlined />}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteClick(dokument.id);
                  }}
                />
              </div>
            </div>
          </List.Item>
        )}
      ></List>
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            {" "}
            Prethodna{" "}
          </button>
          <span>
            Stranica {currentPage} od {totalPages}
          </span>
          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            {" "}
            Sljedeća
          </button>
        </div>
      )}
    </div>
  );
}

export default DokumentsList;
